<template lang="html">
  <div class="progress-bar progress-bar-half-circle">
    <div class="left back-done" v-if="value > 0"></div>
    <div class="left" v-else><div class="back"></div></div>

    <div class="right back-done" v-if="value >= 100"></div>
    <div class="right" v-else><div class="back"></div></div>
    <div class="barOverflow">
      <div class="bar" ref="bar"></div>
    </div>
    <div class="content">
      <div class="progress-bar-value">{{value|format_performance}}%</div>
      <div class="progress-bar-text">Performance</div>
    </div>
  </div>
</template>

<script>

export default {
	props: ['value'],
	data () {
		return {
			animationTimeout: null
		}
	},
	mounted () {
		this.startAnimation()
	},
	activated () {
		this.startAnimation()
	},
	beforeDestroy () {
		if (this.animationTimeout) {
			clearTimeout(this.animationTimeout)
		}
	},
	watch: {
		value () {
			this.startAnimation()
		}
	},
	methods: {
		startAnimation () {
			if (this.animationTimeout) {
				clearTimeout(this.animationTimeout)
			}

			if (this.$refs.bar) {
				this.$refs.bar.style.transform = 'rotate(45deg)'
			}

			this.animationTimeout = setTimeout(() => {
				if (this.$refs.bar) {
					let value = this.value > 100 ? 100 : this.value
					if (value < 0) { value = 0 }
					let percent = 45 + (value * 1.8)
					this.$refs.bar.style.transform = 'rotate(' + percent + 'deg)'
				}
			}, 100)
		}
	},
	filters: {
		format_performance (value) {
			if (!value) {
				return '0'
			}

			if (value === 0) {
				return value.toLocaleString()
			}

			return value > 0 ? ('+' + value.toLocaleString()) : value.toLocaleString()
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/progress-bar-half-circle.vue